export const products = [
  {
    id: '1',
    name: 'Elephant-Shaped Scented Candle',
    scent: 'SEA BREEZE',
    scentsAvailable: ['SEA BREEZE', 'LAVENDER', 'VANILLA'],
    price: 7.90,
    image: 'https://images.unsplash.com/photo-1603218678692-3967d7523bb0?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1603218678692-3967d7523bb0?w=500&h=500&fit=crop',
      'https://images.unsplash.com/photo-1602874801006-47c1e59c364d?w=500&h=500&fit=crop'
    ],
    description: 'Hand-poured elephant-shaped candle with refreshing scent. Perfect for coastal-themed decor. Available in multiple scents.',
    category: 'Shaped Candles',
    badges: ['Bestseller'],
    inStock: true,
    stockCount: 15
  },
  {
    id: '2',
    name: 'Heart-Shaped Scented Candle',
    scent: 'ROSE GARDEN',
    scentsAvailable: ['ROSE GARDEN', 'JASMINE', 'CHERRY BLOSSOM'],
    price: 8.90,
    image: 'https://images.unsplash.com/photo-1614674942931-77393d76e9b4?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1614674942931-77393d76e9b4?w=500&h=500&fit=crop',
      'https://images.unsplash.com/photo-1603218678692-3967d7523bb0?w=500&h=500&fit=crop'
    ],
    description: 'Romantic heart-shaped candle with floral fragrances. Ideal for special occasions. Choose your favorite scent.',
    category: 'Shaped Candles',
    badges: ['New', 'Bestseller'],
    inStock: true,
    stockCount: 20
  },
  {
    id: '3',
    name: 'Layered Scented Candle – Wonderland Edition',
    scent: 'WINTER WONDERLAND',
    scentsAvailable: ['WINTER WONDERLAND', 'AUTUMN LEAVES', 'SPRING BLOOM'],
    price: 10.90,
    image: 'https://images.unsplash.com/photo-1637534370351-86326b4cb972?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1637534370351-86326b4cb972?w=500&h=500&fit=crop',
      'https://images.unsplash.com/photo-1602874801006-47c1e59c364d?w=500&h=500&fit=crop'
    ],
    description: 'Multi-layered candle with seasonal scents. Creates a cozy atmosphere. Multiple scent options available.',
    category: 'Layered Candles',
    badges: ['New'],
    inStock: true,
    stockCount: 12
  },
  {
    id: '4',
    name: 'Rustic Vanilla Bean Candle',
    scent: 'VANILLA BEAN',
    scentsAvailable: ['VANILLA BEAN'],
    price: 12.90,
    image: 'https://images.unsplash.com/photo-1760804876235-42ba2ac060f5?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1760804876235-42ba2ac060f5?w=500&h=500&fit=crop'
    ],
    description: 'Classic rustic candle with pure vanilla bean fragrance. Timeless and elegant.',
    category: 'Classic Candles',
    badges: ['Bestseller'],
    inStock: true,
    stockCount: 8
  },
  {
    id: '5',
    name: 'Lavender Dreams Pillar Candle',
    scent: 'LAVENDER',
    scentsAvailable: ['LAVENDER', 'EUCALYPTUS', 'MINT'],
    price: 14.90,
    image: 'https://images.unsplash.com/photo-1763888476830-75c71621c0bc?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1763888476830-75c71621c0bc?w=500&h=500&fit=crop',
      'https://images.unsplash.com/photo-1602874801006-47c1e59c364d?w=500&h=500&fit=crop'
    ],
    description: 'Tall pillar candle with calming scents. Perfect for relaxation and meditation. Multiple scent options.',
    category: 'Pillar Candles',
    badges: ['New'],
    inStock: true,
    stockCount: 10
  },
  {
    id: '6',
    name: 'Cinnamon Spice Artisan Candle',
    scent: 'CINNAMON SPICE',
    scentsAvailable: ['CINNAMON SPICE', 'PUMPKIN SPICE', 'APPLE PIE'],
    price: 11.90,
    image: 'https://images.unsplash.com/photo-1603218678692-3967d7523bb0?w=500&h=500&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1603218678692-3967d7523bb0?w=500&h=500&fit=crop',
      'https://images.unsplash.com/photo-1637534370351-86326b4cb972?w=500&h=500&fit=crop'
    ],
    description: 'Warm and inviting spiced candles. Fills your space with cozy aromas. Choose from warm spice scents.',
    category: 'Artisan Candles',
    badges: ['Bestseller'],
    inStock: true,
    stockCount: 18
  }
];

export const categories = [
  'Shaped Candles',
  'Layered Candles',
  'Classic Candles',
  'Pillar Candles',
  'Artisan Candles'
];

export const orders = [];
